import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'redux'

import Specifications from './Specifications'
import Card from './Card'
import progressBarHoc from 'containers/Async/AsyncProgressBar'
import PanelSectionHeader from 'components/fulcrum/panelSectionHeader/PanelSectionHeader'
import PanelSection from 'components/fulcrum/panelSection/PanelSection'
import {
  FETCH_FORM_DATA,
} from './constants'

import {
  FETCH_PROJECT_REVISIONS,
  FETCH_REVISION_DATA,
} from 'containers/Project/Revision/constants'

import {
  LOAD_PROJECT_FORM,
  FETCH_FORM_ELEMENTS,
  FETCH_ELEMENT_REFERENCES,
} from 'containers/Project/constants'

const ProgressBar = progressBarHoc(
  [
    FETCH_FORM_DATA,
    LOAD_PROJECT_FORM,
    FETCH_FORM_ELEMENTS,
    FETCH_ELEMENT_REFERENCES,
    FETCH_PROJECT_REVISIONS,
    FETCH_REVISION_DATA,
  ]
)

const ApprovalSpecifications = () => {
  return (
    <PanelSection>
      <PanelSectionHeader label='Specifications Section'/>
      <Card>
        <Specifications/>
        <ProgressBar/>
      </Card>
    </PanelSection>
  )
}

export default ApprovalSpecifications
